import React, { useState, useEffect } from 'react';
import { AddInfoKg } from './AddInfoKg';
import { getPCInfo, savePCInfo } from './actions';

const data = require('./data/schema.json');

export const PCAddInfoKg = ({ kgId, close }) => {
  const [initdata, setInitdata] = useState({});

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const info = await getPCInfo(kgId);

    const updData = (data) => {
      return {
          "6100": data['computers'] && data['computers']['numbers'] || 0,
          "6110": data['computers'] && data['computers']['budget'] || 0,
          "6120": data['computers'] && data['computers']['bad'] || 0,
          "6130": data['computers'] && data['computers']['fiveold'] || 0,
          "6140": data['computers'] && data['computers']['managed'] || 0,
          "6150": data['computers'] && data['computers']['internet_wired'] || 0,
          "6160": data['computers'] && data['computers']['internet_wifi'] || 0,
          "6170": data['laptops'] || 0,
          "6180": data['pads'] || 0,
          "6210": data['interact'] && data['interact']['board'] || 0,
          "6220": data['interact'] && data['interact']['module'] || 0,
          "6230": data['interact'] && data['interact']['display'] || 0,
          "6310": data['noninteract'] && data['noninteract']['projectors'] || 0,
          "6320": data['noninteract'] && data['noninteract']['tv'] || 0,
          "6330": data['noninteract'] && data['noninteract']['other'] || 0,
          "6400": data['printers'] || 0,
          "6500": data['internetspeedwired'] || 0,
          "6600": data['internetspeedwifi'] || 0,
          "PC19": data['sysadmin'],
          'PC29': data['need_devices_pc']  || 0,
          'PC30': data['need_devices_laptops'] || 0,
          'PC31': data['need_devices_tablets'] || 0,
          'PC32': data['need_software_os'] || 0,
          'PC33': data['need_software_office'] || 0,
          'PCOSWIN': data['PCOSWIN'],
          'PCOSMAC': data['PCOSMAC'], 'PCOSCLOUD': data['PCOSCLOUD'], 'PCOSANDROID': data['PCOSANDROID'],
          'PCOSIOS': data['PCOSIOS'], 'PCOSOTHER': data['PCOSOTHER']
};
    };

    if (info?.data?.[0]?.['itinfrastructure']) {
      setInitdata(updData(info.data[0]['itinfrastructure']));
    }
  };

  const saveData = async (data) => {
    const data_obj = {
      computers:{
                numbers: data['6100'],
                budget: data['6110'],
                fiveold: data['6130'],
                bad: data['6120'],
                managed: data['6140'],
                internet_wired: data['6150'],
                internet_wifi: data['6160']
            },
            laptops: data['6170'],
            pads: data['6180'],
            interact: {
                board: data['6210'],
                module: data['6220'],
                display: data['6230'] 
            },
            noninteract: {
                projectors: data['6310'],
                tv: data['6320'],
                other: data['6330']
            },
            printers: data['6400'],
            internetspeedwired: data['6500'],
            internetspeedwifi: data['6600'],
            sysadmin: data['PC19'] ? 1 : 0,
            need_devices_pc: data['PC29'],
            need_devices_laptops: data['PC30'],
            need_devices_tablets: data['PC31'],
            need_software_os: data['PC32'],
            need_software_office: data['PC33'],
            'PCOSWIN': data['PCOSWIN'],
            'PCOSMAC': data['PCOSMAC'], 
            'PCOSCLOUD': data['PCOSCLOUD'], 
            'PCOSANDROID': data['PCOSANDROID'],
            'PCOSIOS': data['PCOSIOS'], 
            'PCOSOTHER': data['PCOSOTHER']
    };

    const result = await savePCInfo(kgId, data_obj);

    alert((result.data?.nModified && result.data?.nModified == 1) ? `Інформація збережена успішно` : `Вибачте, але виникла помилка під час збереження`);
      
  };


  return (
    <AddInfoKg 
      data={data} 
      initdata={initdata} 
      save={saveData} 
      close={close}
    />
  );
};